export default __webpack_public_path__ + "static/media/IMG_8150.6e794b00.webp";